<template lang="pug">
control
  field(:class="{ invalid: !dateTime.meta.valid && dateTime.meta.touched }")
    label(:for="dateTime.id")(v-html="dateTime.label")
    input(
      @blur="dateTime.blur",
      v-model="dateTime.model",
      :min="dateTime.min",
      :max="dateTime.max",
      :type="dateTime.type",
      :name="dateTime.id",
      :id="dateTime.id",
      :placeholder="dateTime.placeholder()",
    )
    error(v-if="!dateTime.meta.valid && dateTime.meta.touched") {{ dateTime.errorMessage }}
</template>

<script>
import { useStore } from 'vuex';
import { reactive, computed } from 'vue';
import { useField } from 'vee-validate';
import { parse, isDate, isValid } from 'date-fns';
import { required } from '../composables/required.js';

import * as yup from 'yup';

export default {
  name: 'DateTime',
  props: {
    field: Object,
  },
  setup(p) {
    const store = useStore();
    const dateTime = reactive(initDateTime());

    return { dateTime };

    function parseDateString(value, originalValue) {
      let parsedDate = isDate(originalValue)
        ? originalValue
        : parse(originalValue, 'yyyy-MM-dd', new Date());

      if (isDate(parsedDate) && isValid(parsedDate)) {
        return parsedDate;
      }

      return originalValue;
    }

    function initDateTime() {
      const calcDate = f => new Date(new Function(f)()).toISOString().substring(0, 10);

      const field = computed(() => p.field);
      const id = field.value.id;
      const type = field.value.time === true ? 'datetime-local' : 'date';
      const min = field.value.minCalc
        ? calcDate(field.value.minCalc)
        : field.value.min
        ? field.value.min
        : false;
      const max = field.value.maxCalc
        ? calcDate(field.value.maxCalc)
        : field.value.max
        ? field.value.max
        : false;

      let rulesBase = yup.date().transform(parseDateString);

      if (min) {
        rulesBase = rulesBase.min(min, schema => {
          let minAsString = parse(
            schema.min,
            'yyyy-MM-dd',
            new Date()
          ).toLocaleDateString('en-us');

          return `The date must be after ${minAsString}.`;
        });
      }
      if (max) {
        rulesBase = rulesBase.max(max, schema => {
          let maxAsString = parse(
            schema.max,
            'yyyy-MM-dd',
            new Date()
          ).toLocaleDateString('en-us');

          return `The date must be before ${maxAsString}.`;
        });
      }

      const { rules, label, isRequired } = required(field, rulesBase);

      const { value, errorMessage, meta, handleBlur, validate } = useField(id, rules, {
        validateOnInput: true,
        initialValue: store.getters.model[id],
      });

      const model = computed({
        get: () => store.getters.model[id],
        set: v => {
          value.value = v;
          store.commit('updateModel', { id, value: v });
        },
      });

      const blur = async () => {
        store.commit('pushLastFieldToDataLayer', id);
        await validate();
        handleBlur();
      };

      const placeholder = () => {
        return isRequired.value ? "(Required)" : "";
      };

      return { id, label, type, min, max, model, meta, blur, errorMessage, placeholder };
    }
  },
};
</script>

<style lang="scss" scoped></style>
